import { render, staticRenderFns } from "./CorrelationDischargeData.vue?vue&type=template&id=5b0fee82&scoped=true"
import script from "./CorrelationDischargeData.vue?vue&type=script&lang=js"
export * from "./CorrelationDischargeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fee82",
  null
  
)

export default component.exports